import React, { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import './Cube.css'


export const Cube = ({scale}) => {

    function Box(props) {

        const ref = useRef()

        useFrame((state, delta) => (ref.current.rotation.x += 0.03))
        useFrame((state, delta) => (ref.current.rotation.y += 0.02))
        
        
        return (
            <mesh
                {...props}
                ref={ref}>
                <boxGeometry args={[1, 1, 1]} />
                <meshStandardMaterial color={'#65f4ad'} />
            </mesh>
        )
    }

    return <div className='loader'>
        <Canvas >
            {/* <ambientLight /> */}
            <pointLight position={[0, 0, 15]} />
            <Box position={[0, 0, 0]} scale={scale} />
        </Canvas>
    </div>;
};
